/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiASkipForwardIcon16Solid = forwardRef('MediaUiASkipForwardIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "m4.515 2.255 6.354 4.433c.046.032.09.066.131.101V3a1 1 0 1 1 2 0v10a1 1 0 1 1-2 0V9.212c-.041.035-.085.07-.13.101l-6.355 4.433C3.455 14.485 2 13.726 2 12.433V3.567c0-1.293 1.455-2.052 2.515-1.312Z" })));
});
